// extracted by mini-css-extract-plugin
export var icon = "NavPrimary-module--icon--aba5f";
export var inner = "NavPrimary-module--inner--18c4e";
export var item = "NavPrimary-module--item--af5f7";
export var link = "NavPrimary-module--link--69e76";
export var linkInner = "NavPrimary-module--linkInner--887e2";
export var megaMenu = "NavPrimary-module--megaMenu--f9551";
export var menu = "NavPrimary-module--menu--cf230";